export default __webpack_public_path__ + "static/media/WhatBackground.3c32c852.webp";